shadow$provide[126] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, VRControls:{enumerable:true, get:function() {
  return VRControls;
}}});
var require$three = require("three");
class VRControls {
  constructor(object, onError) {
    this.object = object;
    this.standingMatrix = new require$three.Matrix4();
    this.frameData = null;
    if ("VRFrameData" in window) {
      this.frameData = new VRFrameData();
    }
    function gotVRDisplays(displays) {
      this.vrDisplays = displays;
      if (displays.length > 0) {
        this.vrDisplay = displays[0];
      } else {
        if (onError) {
          onError("VR input not available.");
        }
      }
    }
    if (navigator.getVRDisplays) {
      navigator.getVRDisplays().then(gotVRDisplays).catch(function() {
        console.warn("VRControls: Unable to get VR Displays");
      });
    }
    this.scale = 1;
    this.standing = false;
    this.userHeight = 1.6;
  }
  getVRDisplay() {
    return this.vrDisplay;
  }
  setVRDisplay(value) {
    this.vrDisplay = value;
  }
  getVRDisplays() {
    console.warn("VRControls: getVRDisplays() is being deprecated.");
    return this.vrDisplays;
  }
  getStandingMatrix() {
    return this.standingMatrix;
  }
  update() {
    if (this.vrDisplay) {
      let pose;
      if (this.vrDisplay.getFrameData) {
        this.vrDisplay.getFrameData(this.frameData);
        pose = this.frameData.pose;
      } else if (this.vrDisplay.getPose) {
        pose = this.vrDisplay.getPose();
      }
      if (pose.orientation !== null) {
        this.object.quaternion.fromArray(pose.orientation);
      }
      if (pose.position !== null) {
        this.object.position.fromArray(pose.position);
      } else {
        this.object.position.set(0, 0, 0);
      }
      if (this.standing) {
        if (this.vrDisplay.stageParameters) {
          this.object.updateMatrix();
          this.standingMatrix.fromArray(this.vrDisplay.stageParameters.sittingToStandingTransform);
          this.object.applyMatrix(this.standingMatrix);
        } else {
          this.object.position.setY(this.object.position.y + this.userHeight);
        }
      }
      this.object.position.multiplyScalar(this.scale);
    }
  }
  dispose() {
    this.vrDisplay = null;
  }
}

};